<template>
  <div class="login-shell">
    <section class="login-introduction">
      <button type="button" class="login-brand" @click="home">
        <span class="login-brand__mark"><v-icon color="white">school</v-icon></span>
        <span class="login-brand__name">taleem<span>.app</span></span>
      </button>
      <div class="login-introduction__content">
        <div class="login-eyebrow">Masjid administration</div>
        <h1>Everything your learning community needs.</h1>
        <p>
          Manage students, classrooms, teachers, payments, and report cards
          from one organized workspace.
        </p>
        <div class="login-feature">
          <v-icon>check_circle</v-icon>
          <span>Simple, secure, and built for your community</span>
        </div>
      </div>
    </section>

    <v-card class="login-card" elevation="0">
      <div class="login-card__heading">
        <div class="login-card__icon"><v-icon>lock_open</v-icon></div>
        <div>
          <div class="login-eyebrow">Welcome back</div>
          <h2>Sign in to your account</h2>
          <p>Enter your organization and account details below.</p>
        </div>
      </div>

      <v-card-text class="login-card__body">
        <div class="login-card__fields">
          <v-text-field
            ref="locationCode"
            v-model.trim="code"
            :error-messages="codeErrors"
            label="Organization code"
            prepend-inner-icon="business"
            outlined
            hide-details="auto"
            class="login-field"
            @blur="$v.code.$touch()"
          ></v-text-field>

          <v-text-field
            v-model.trim="email"
            :error-messages="emailErrors"
            label="Email address"
            prepend-inner-icon="email"
            outlined
            hide-details="auto"
            class="login-field"
            @blur="$v.email.$touch()"
          ></v-text-field>

          <v-text-field
            v-model="password"
            :append-icon="showPassword ? 'visibility_off' : 'visibility'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('labels.password')"
            :error-messages="passwordErrors"
            prepend-inner-icon="lock"
            outlined
            hide-details="auto"
            class="login-field"
            @keyup.enter="submit"
            @input="$v.password.$touch()"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </div>

        <div class="login-card__help">
          <button type="button" @click="$router.push({ path: '/forgot' })">
            Forgot password?
          </button>
        </div>

        <v-btn
          :loading="loading"
          class="login-submit"
          color="primary"
          depressed
          block
          large
          @click="submit"
        >
          {{ $t("buttons.login") }}
          <v-icon right>arrow_forward</v-icon>
        </v-btn>
      </v-card-text>

      <div class="login-card__signup">
        <span>New to taleem?</span>
        <button type="button" @click="$router.push({ path: '/signup' })">
          Create an account
        </button>
      </div>
    </v-card>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import authService from "../service";
// import GoogleLogin from "./GoogleLogin";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      showPassword: false,
      email: null,
      loading: false,
      password: null,
      code: null,
    };
  },
  created() {
    const localStoreCode = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
    if (localStoreCode) {
      this.code = localStoreCode;
    }
    // console.log("created in login", this.code);
  },
  methods: {
    ...mapActions("global", ["initBusiness", "initUser"]),
    submitLocation() {
      console.log("submitLocation", this.code);
    },
    home() {
      window.open("https://taleem.com", "_self");
    },
    // checkResponse(response) {
    //   if (response.status === 400) {
    //     this.$swal
    //       .mixin({
    //         toast: true,
    //         position: "top-end",
    //         showConfirmButton: false,
    //         timer: 3000,
    //       })
    //       .fire({
    //         icon: "error",
    //         title: "Invalid User",
    //       });
    //   } else {
    //     // this.initUser()
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}code`,
    //       this.code
    //     );
    //     // console.log('tesetd', response.user)
    //     if (response.user.userType === 'teacher') {
    //       this.$router.push({ name: "thome" });
    //       // return false
    //     }
    //     else {
    //       this.$router.push({ name: "home" });
    //       // return false
    //     }

    //   }
    // },
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Invalid User",
          });
        return;
      }

      // Save code
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`,
        this.code
      );

      // If teacher, block app login and redirect them to teacher portal
      if (response?.user?.userType === "teacher") {
        this.$swal
          .fire({
            icon: "info",
            title: "Teacher account",
            html: `Teachers now sign in at <b>teacher.taleem.app</b>.<br/>Click Continue to go there.`,
            confirmButtonText: "Continue",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
          })
          .then((result) => {
            const confirmed =
              result === true ||
              result?.isConfirmed === true ||
              result?.value === true;

            if (confirmed) {
              // replace is a bit cleaner than href (no back button to this page)
              window.location.replace("https://teacher.taleem.app");
            }
          });

        return;
      }

      // Normal users return to the secure page that originally brought them
      // to login, such as a time-off approval link.
      const redirect = String(this.$route.query.redirect || "");
      this.$router.push(redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : { name: "home" });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.$Progress.start();
        console.log("login submit", this.email, this.password, this.code);
        authService
          .authenticate({
            email: this.email,
            password: this.password,
            code: this.code,
          })
          .then((response) => {
            this.$Progress.finish();
            // console.log('response after login', response)
            this.checkResponse(response);
            this.loading = false;
          })
          .catch((error) => {
            this.$Progress.finish();
            this.loading = false;
            console.log("error on ", error);
            const message =
              (error && error.data && error.data.message) ||
              (error && error.message) ||
              "Unable to reach the Taleem server. Please confirm the backend is running.";
            this.$swal("Login Failed", message, "error");
          });
      }
    },
  },
  computed: {
    codeErrors() {
      const errors = [];
      if (!this.$v.code.$dirty) return errors;
      if (!this.$v.code.required) errors.push("Code is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
    code: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>
